import React, { useEffect, useState } from 'react'
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

import IconArrowRight from "./icons/IconArrowRight"
import IconCheckGreen from "./icons/IconCheckGreen"

export default () => {

    const data = useStaticQuery(graphql`
        query {
            wpMenu(locations: { eq: MOBILE_MENU }) {
                id
                name
                menuItems {
                    nodes {
                        id
                        label
                        path
                        parentDatabaseId
                        cssClasses
                        childItems {
                            nodes {
                                id
                                label
                                path
                                parentDatabaseId
                            }
                        }
                    }
                }
            }
        }
    `)
    const [isNavExpanded, setIsNavExpanded] = useState(false)
    const [isSubNavExpanded, setIsSubNavExpanded] = useState(false)

    function toggleSubmenu(id) {

        document.getElementById('submenu_' + id).classList.toggle("active")

    }

    const [isButtonDisabled, setButtonDisabled] = useState(true);

    const [allLocations, setAllLocations] = useState([])

    useEffect(() => {
        fetch(`https://api.rekord-fenster.com/main/getallmainlocations?detail=true`)
            .then(response => response.json())
            .then(resultData => {
                setAllLocations(resultData.data)
            })
    }, [])

    const [isPriceCalculatorExpanded, setIsPriceCalculatorExpanded] = useState(false)
    const [isDoorsCalculatorExpanded, setIsDoorsCalculatorExpanded] = useState(false)

    useEffect(() => {
        if (isNavExpanded || isPriceCalculatorExpanded) {
            document.body.classList.add("overflow-hidden", "h-screen")
        } else {
            document.body.classList.remove("overflow-hidden", "h-screen")
        }
    }, [isNavExpanded, isPriceCalculatorExpanded])

    function contactKeyPressed(e) {
        const isNumber = /^[0-9]$/.test(e.key)
        const isEnter = e.key === 'Enter'

        if (!isNumber && !isEnter) {
            e.preventDefault()
            return
        }

        const input = document.getElementById('calculatorPostCode')
        const value = input.value

        document.getElementById('calculatorStart').classList.remove('hidden')
        document.getElementById('calculatorSuccess').classList.add('hidden')

        if (value.length >= 4 || isEnter) {
            getSellerContacts(value)
        }
    }


    function getSellerContacts(zip) {

        var plz = parseInt(zip)
        var plzString = zip
        var errorWrapper = document.getElementById('calculatorError')

        errorWrapper.innerHTML = ''

        const locationDropdown = document.getElementById('calculatorLocationSelectorDropdown')
        const locationErrorMsg = document.getElementById('calculatorLocationSelectorError')
        const automatic = document.getElementById('calculatorLocationSelectorAutomatic')

        if (Number.isInteger(plz)) {

            if (plz.toString().length < 4) {

                errorWrapper.innerHTML = 'PLZ ist zu kurz'
                document.getElementById('calculatorStart').classList.remove("hidden")
                document.getElementById('calculatorSuccess').classList.add("hidden")
                setButtonDisabled(true)

            } else if (plz.toString().length >= 4) {

                document.getElementById('calculatorStart').classList.add("hidden")
                document.getElementById('calculatorSuccess').classList.remove("hidden")

                window.fetch("https://api.rekord-fenster.com/main/getadviser/" + plz)
                    .then(response => response.json())
                    .then(
                        response => {

                            if (response.success === true) {

                                document.getElementById('calculatorResponseError').classList.add("hidden")
                                locationErrorMsg.dataset.error = 'false'
                                locationErrorMsg.classList.add('hidden')

                                automatic.dataset.configuratorUrl = response.data.haustuerkonfigurator

                                window.open(response.data.haustuerkonfigurator, '_blank')
                                setIsDoorsCalculatorExpanded(false)
                                setIsPriceCalculatorExpanded(false)

                                setButtonDisabled(false)


                            } else {

                                document.getElementById('calculatorResponseError').classList.remove("hidden")
                                locationErrorMsg.dataset.error = 'true'
                                locationErrorMsg.classList.remove('hidden')

                                setButtonDisabled(true)

                            }

                        },
                        errorData => {
                            console.log('ERROR')
                        }
                    )

            }

        } else {

            if (plzString.length === 0) {
                errorWrapper.innerHTML = 'PLZ ist zu kurz'
            } else {
                errorWrapper.innerHTML = 'PLZ muss numerisch sein!'
            }

        }

        // console.log(plz)
        // console.log(plzString.length)
        // console.log(plz.toString().length)
        // console.log(Number.isInteger(plz))

    }

    return (
        <>

            <div className="cursor-pointer 2xl:col-span-2 relative">
                <button
                    className={isPriceCalculatorExpanded ? "price-calculator price-calculator-opened" : "price-calculator"}
                    onClick={() => {
                        setIsPriceCalculatorExpanded(!isPriceCalculatorExpanded);
                        setIsNavExpanded(false)
                    }}
                >
                    <svg id="price-calculator-icon" className="block mx-auto mb-0.5" width="40" height="40" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                        <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="price-calculato" transform="translate(-1217.000000, -23.000000)" fillRule="nonzero">
                                <g id="CTA-Button-Preisrechner" transform="translate(1187.000000, 0.000000)">
                                    <g id="GLOBAL/Icons/Diverses/Preisrechner-Weiß" transform="translate(30.800000, 23.000000)">
                                        <path d="M38.2670363,24.5758755 L36.8401011,20.2095821 C36.7986632,20.0833464 36.7986632,19.9472177 36.8401011,19.820982 L38.2670363,15.4546886 C38.6154531,14.3873176 38.2334367,13.2176349 37.3215823,12.5598361 L33.5835372,9.84836789 C33.4761412,9.77033104 33.3964254,9.66022785 33.3559279,9.53399477 L31.9289926,5.16770139 C31.5830493,4.09957362 30.5855749,3.37624979 29.4603071,3.37752111 L24.8380874,3.37752111 C24.7061352,3.37786643 24.5774488,3.33660508 24.4704108,3.25963118 L20.7367428,0.500133769 C19.824808,-0.166711256 18.5847061,-0.166711256 17.6727714,0.500133769 L13.9347263,3.21160196 C13.8278261,3.28884761 13.6990485,3.33013818 13.5670497,3.32949188 L8.94920707,3.32949188 C7.82393928,3.32822057 6.82646485,4.05154439 6.48052153,5.11967216 L5.05358628,9.52089589 C5.01336531,9.64726808 4.93359227,9.75745031 4.82597697,9.83526901 L1.08355476,12.5249057 C0.171700346,13.1827046 -0.210316072,14.3523872 0.138100723,15.4197582 L1.56503598,19.7860516 C1.60647383,19.9122873 1.60647383,20.048416 1.56503598,20.1746517 L0.138100723,24.5409451 C-0.229649519,25.6199597 0.154424157,26.8119049 1.08355476,27.4750943 L4.83035408,30.1865625 C4.93796937,30.2643812 5.01774242,30.3745634 5.05796338,30.5009356 L6.48489864,34.867229 C6.83084195,35.9353567 7.82831638,36.6586806 8.95358417,36.6574092 L13.5845581,36.6574092 C13.7165102,36.6570639 13.8451967,36.6983253 13.9522347,36.7752992 L17.6859027,39.4998662 C18.5978374,40.1667113 19.8379393,40.1667113 20.7498741,39.4998662 L24.4879192,36.788398 C24.5949572,36.7114242 24.7236436,36.6701628 24.8555958,36.6705081 L29.4603071,36.6705081 C30.5855749,36.6717794 31.5830493,35.9484556 31.9289926,34.8803278 L33.3559279,30.5140345 C33.3964254,30.3878014 33.4761412,30.2776982 33.5835372,30.1996613 L37.3215823,27.4881931 C38.2422716,26.8288459 38.6254808,25.648432 38.2670363,24.5758755 Z M24.0543317,29.2 L18.8197694,29.2 C16.0446925,29.1951978 13.7962268,26.9131627 13.7914952,24.0966543 L13.7914952,23.3464188 L12.3775616,23.3464188 C11.7272123,23.3464188 11.2,22.8113353 11.2,22.1512763 C11.2,21.4912174 11.7272123,20.9561338 12.3775616,20.9561338 L13.7914952,20.9561338 L13.7914952,19.9659975 L12.8803891,19.9659975 C12.2300397,19.9659975 11.7028274,19.430914 11.7028274,18.770855 C11.7028274,18.110796 12.2300397,17.5757125 12.8803891,17.5757125 L13.7914952,17.5757125 L13.7914952,16.7033457 C13.7962268,13.8868373 16.0446925,11.6048022 18.8197694,11.6 L22.9326398,11.6 C23.5584454,11.6323654 24.0505865,12.1548192 24.0543317,12.7907807 L24.0543317,12.7907807 C24.0543317,13.4436127 23.5328918,13.9728377 22.8896631,13.9728377 L18.8197694,13.9728377 C17.3446722,13.9752024 16.1474619,15.1844452 16.1380231,16.6815366 L16.1380231,17.5539033 L20.375526,17.5539033 C20.7962283,17.5539033 21.1849732,17.7816962 21.3953243,18.1514746 C21.6056755,18.521253 21.6056755,18.9768387 21.3953243,19.3466171 C21.1849732,19.7163955 20.7962283,19.9441884 20.375526,19.9441884 L16.1380231,19.9441884 L16.1380231,20.9604957 L21.4198599,20.9604957 C22.0702092,20.9604957 22.5974214,21.4955792 22.5974214,22.1556382 C22.5974214,22.8156971 22.0702092,23.3507806 21.4198599,23.3507807 L16.1595115,23.3507807 L16.1595115,24.0966543 C16.1618778,25.5988584 17.3611514,26.8160371 18.8412577,26.8184387 L23.998462,26.8184387 L23.998462,26.8184387 C24.6464378,26.8027804 25.1842328,27.3232174 25.1996608,27.9808674 C25.2150888,28.6385174 24.7023075,29.1843416 24.0543317,29.2 L24.0543317,29.2 Z" id="Shape"></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                    Preisrechner
                </button>

                <div className={isPriceCalculatorExpanded ? "calculator-nav opened" : "calculator-nav"}>
                    <div className="flex justify-between items-center mb-2">
                        <h4 className={isDoorsCalculatorExpanded ? "text-sm uppercase m-0 opacity-0" : "text-sm uppercase m-0"}>Preise für:</h4>
                        <button className="text-rekord-dgray text-xs" onClick={() => { setIsPriceCalculatorExpanded(!isPriceCalculatorExpanded) }}><span className="text-black font-bold">&times;</span> Schließen</button>
                    </div>
                    <ul className={isDoorsCalculatorExpanded ? "hidden" : "block"}>
                        <li>
                            <a href="https://preisrechner.rekord-fenster.com/" target="_blank" title="Preisrechner: Fenster / Balkontüren / Sonnenschutz">Fenster / Balkontüren / Sonnenschutz</a>
                        </li>
                        <li>
                            <button onClick={() => { setIsDoorsCalculatorExpanded(!isDoorsCalculatorExpanded) }}>Haustüren</button>
                        </li>
                    </ul>
                    <div className={isDoorsCalculatorExpanded ? "block" : "hidden"}>
                        <span className="text-xs">Über die PLZ bekommst du aktuelle Angebote vom Standort in deiner Nähe</span>
                        <div className="form-group">
                            <label htmlFor="contactPostCode">PLZ</label>
                            <input
                                id="calculatorPostCode"
                                maxLength={6}
                                type="number"
                                placeholder="z.B.: 9500"
                                onKeyUp={contactKeyPressed}
                            />
                            <button onClick={() => { getSellerContacts(document.getElementById('calculatorPostCode').value) }} >
                                <span id="calculatorSuccess" className="hidden"><IconCheckGreen w="48" h="60" /></span>
                                <span id="calculatorStart"><IconArrowRight w="24" h="40" /></span>
                            </button>
                        </div>
                        <div>
                            <p id="calculatorLocationSelectorError" data-error="false" className="mt-6 mb-2 text-sm text-red-700 border border-red-700 bg-red-200 p-2 hidden">Deine PLZ konnte nicht zugeordnet werden. Korrigiere die PLZ oder wähle einen Standort aus</p>
                            <p className="mt-6 mb-2 text-xs">Wenn du willst, wähle hier einen anderen Standort:</p>
                            <select
                                id="calculatorLocationSelectorDropdown"
                                className="dropdown-options dropdown-locations"
                            >
                                <option id="calculatorLocationSelectorAutomatic" value="0" data-configurator-url="0">automatisch</option>
                                {allLocations.map((loc, i) => (
                                    <option key={i} className="dropdown-option" value={loc.locationId} data-configurator-url={loc.haustuerkonfigurator}>{loc.location_name}</option>
                                ))}
                            </select>
                            <button
                                className="btn btn-green mt-4"
                                disabled={isButtonDisabled}
                                onClick={() => {
                                    const calculatorLocationSelectorDropdown = document.getElementById('calculatorLocationSelectorDropdown')
                                    window.open(calculatorLocationSelectorDropdown.options[calculatorLocationSelectorDropdown.selectedIndex].dataset.configuratorUrl, '_blank')
                                    setIsDoorsCalculatorExpanded(false)
                                    setIsPriceCalculatorExpanded(false)
                                }}
                            >Jetzt berechnen</button>
                        </div>
                        <div id="calculatorError" className="text-red-500 text-xs"></div>
                        <div id="calculatorResponseError" className="hidden text-red-500 my-2 text-xs">PLZ konnte nicht gefunden werden. Bitte versuche es erneut.</div>
                        <button className="text-rekord-dgray text-xs mt-4" onClick={() => { setIsDoorsCalculatorExpanded(!isDoorsCalculatorExpanded) }}><span className="text-black font-bold">&#60;</span> Zurück</button>
                    </div>
                </div>
            </div>

            {isPriceCalculatorExpanded && <div className="menu-overlay" onClick={() => setIsPriceCalculatorExpanded(false)} />}

            <div className="flex items-center">
                <button onClick={() => { setIsNavExpanded(!isNavExpanded); setIsPriceCalculatorExpanded(false) }} className="px-4 lg:px-6 py-6">
                    {!isNavExpanded ?
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="18" viewBox="0 0 24 18">
                            <g id="Icon_Burger" data-name="Icon Burger" transform="translate(0 0.5)">
                                <path id="Path" d="M0,.5H24" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2" />
                                <path id="Path-2" data-name="Path" d="M0,.5H24" transform="translate(0 8)" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2" />
                                <path id="Path-3" data-name="Path" d="M0,.5H24" transform="translate(0 16)" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="2" />
                            </g>
                        </svg>
                        :
                        <svg fill="#fff" width="24" height="24" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                            <path fill="#fff" d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z" />
                        </svg>
                    }
                </button>

                {isNavExpanded && <div className="menu-overlay" onClick={() => setIsNavExpanded(false)} />}

                <div className={isNavExpanded ? "nav-menu opened h-screen" : "nav-menu h-0"}>
                    <div className="h-full max-h-screen bg-rekord-dgray overflow-y-auto">
                        <nav>
                            <ul className="nav whitespace-nowrap pb-0">
                                {data &&
                                    data.wpMenu &&
                                    data.wpMenu.menuItems &&
                                    data.wpMenu.menuItems.nodes &&
                                    data.wpMenu.menuItems.nodes.map(
                                        prop => {
                                            const [isSubNavExpanded, setIsSubNavExpanded] = useState(false)

                                            if (prop.parentDatabaseId === 0 && prop.childItems.nodes.length > 0) {

                                                return (
                                                    <li key={prop.id} className={isSubNavExpanded ? "nav-item font-bold " + prop.cssClasses : "nav-item font-bold " + prop.cssClasses}>
                                                        <button onClick={(e) => { toggleSubmenu(prop.id); e.target.classList.toggle('active') }} className="nav-link">
                                                            {prop.label}
                                                        </button>
                                                        <ul id={'submenu_' + prop.id} className={isSubNavExpanded ? "nav-submenu active" : "nav-submenu"}>                                                        {prop && prop.childItems && prop.childItems.nodes.map(child => {
                                                            return (
                                                                <Link key={child.id} className="nav-submenu-item" to={child.path} title={child.label}>{child.label}</Link>
                                                            )
                                                        })}
                                                        </ul>
                                                    </li>
                                                )
                                            } else if (prop.parentDatabaseId === 0 && prop.childItems.nodes.length === 0) {

                                                return (
                                                    <li key={prop.id} className={"nav-item " + prop.cssClasses}>
                                                        <Link className="nav-link" to={prop.path} title={prop.label}>{prop.label}</Link>
                                                    </li>
                                                )
                                            }
                                        }
                                    )}
                            </ul>
                            <div className='px-4 mt-6 mb-24'>
                                <ul className='grid grid-cols-2 gap-4 py-6 list-none m-0 border-t border-white'>
                                    <li>
                                        <Link to={'/standorte'} title='Standorte'>Standorte</Link>
                                    </li>
                                    <li>
                                        <Link to={'/referenzen'} title='Galerie'>Galerie</Link>
                                    </li>
                                    <li>
                                        <Link to={'/karriere'} title='Karriere'>Karriere</Link>
                                    </li>
                                    <li>
                                        <Link to={'/messen'} title='Messen'>Messen</Link>
                                    </li>
                                    <li>
                                        <Link to={'/20-jahre-langzeit-garantie'} title='20 Jahre Garantie'>20 Jahre Garantie</Link>
                                    </li>
                                    <li>
                                        <Link to={'/downloads'} title='Downloads'>Downloads</Link>
                                    </li>
                                </ul>
                            </div>
                        </nav>
                    </div>
                    <div className="absolute bottom-0 p-3 w-full bg-rekord-dgray">
                        <button onClick={() => { setIsNavExpanded(false); setIsPriceCalculatorExpanded(true) }} className='w-full block bg-rekord-orange text-white px-4 py-2 text-sm font-semibold uppercase rounded-lg text-center'>
                            <svg className="inline-block mr-2" width="40" height="40" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                                <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <g id="DKT-Nav-+-CD/Nav-Bar/Grau-dunkel" transform="translate(-1217.000000, -23.000000)" fill="#FFFFFF" fillRule="nonzero">
                                        <g id="CTA-Button-Preisrechner" transform="translate(1187.000000, 0.000000)">
                                            <g id="GLOBAL/Icons/Diverses/Preisrechner-Weiß" transform="translate(30.800000, 23.000000)">
                                                <path d="M38.2670363,24.5758755 L36.8401011,20.2095821 C36.7986632,20.0833464 36.7986632,19.9472177 36.8401011,19.820982 L38.2670363,15.4546886 C38.6154531,14.3873176 38.2334367,13.2176349 37.3215823,12.5598361 L33.5835372,9.84836789 C33.4761412,9.77033104 33.3964254,9.66022785 33.3559279,9.53399477 L31.9289926,5.16770139 C31.5830493,4.09957362 30.5855749,3.37624979 29.4603071,3.37752111 L24.8380874,3.37752111 C24.7061352,3.37786643 24.5774488,3.33660508 24.4704108,3.25963118 L20.7367428,0.500133769 C19.824808,-0.166711256 18.5847061,-0.166711256 17.6727714,0.500133769 L13.9347263,3.21160196 C13.8278261,3.28884761 13.6990485,3.33013818 13.5670497,3.32949188 L8.94920707,3.32949188 C7.82393928,3.32822057 6.82646485,4.05154439 6.48052153,5.11967216 L5.05358628,9.52089589 C5.01336531,9.64726808 4.93359227,9.75745031 4.82597697,9.83526901 L1.08355476,12.5249057 C0.171700346,13.1827046 -0.210316072,14.3523872 0.138100723,15.4197582 L1.56503598,19.7860516 C1.60647383,19.9122873 1.60647383,20.048416 1.56503598,20.1746517 L0.138100723,24.5409451 C-0.229649519,25.6199597 0.154424157,26.8119049 1.08355476,27.4750943 L4.83035408,30.1865625 C4.93796937,30.2643812 5.01774242,30.3745634 5.05796338,30.5009356 L6.48489864,34.867229 C6.83084195,35.9353567 7.82831638,36.6586806 8.95358417,36.6574092 L13.5845581,36.6574092 C13.7165102,36.6570639 13.8451967,36.6983253 13.9522347,36.7752992 L17.6859027,39.4998662 C18.5978374,40.1667113 19.8379393,40.1667113 20.7498741,39.4998662 L24.4879192,36.788398 C24.5949572,36.7114242 24.7236436,36.6701628 24.8555958,36.6705081 L29.4603071,36.6705081 C30.5855749,36.6717794 31.5830493,35.9484556 31.9289926,34.8803278 L33.3559279,30.5140345 C33.3964254,30.3878014 33.4761412,30.2776982 33.5835372,30.1996613 L37.3215823,27.4881931 C38.2422716,26.8288459 38.6254808,25.648432 38.2670363,24.5758755 Z M24.0543317,29.2 L18.8197694,29.2 C16.0446925,29.1951978 13.7962268,26.9131627 13.7914952,24.0966543 L13.7914952,23.3464188 L12.3775616,23.3464188 C11.7272123,23.3464188 11.2,22.8113353 11.2,22.1512763 C11.2,21.4912174 11.7272123,20.9561338 12.3775616,20.9561338 L13.7914952,20.9561338 L13.7914952,19.9659975 L12.8803891,19.9659975 C12.2300397,19.9659975 11.7028274,19.430914 11.7028274,18.770855 C11.7028274,18.110796 12.2300397,17.5757125 12.8803891,17.5757125 L13.7914952,17.5757125 L13.7914952,16.7033457 C13.7962268,13.8868373 16.0446925,11.6048022 18.8197694,11.6 L22.9326398,11.6 C23.5584454,11.6323654 24.0505865,12.1548192 24.0543317,12.7907807 L24.0543317,12.7907807 C24.0543317,13.4436127 23.5328918,13.9728377 22.8896631,13.9728377 L18.8197694,13.9728377 C17.3446722,13.9752024 16.1474619,15.1844452 16.1380231,16.6815366 L16.1380231,17.5539033 L20.375526,17.5539033 C20.7962283,17.5539033 21.1849732,17.7816962 21.3953243,18.1514746 C21.6056755,18.521253 21.6056755,18.9768387 21.3953243,19.3466171 C21.1849732,19.7163955 20.7962283,19.9441884 20.375526,19.9441884 L16.1380231,19.9441884 L16.1380231,20.9604957 L21.4198599,20.9604957 C22.0702092,20.9604957 22.5974214,21.4955792 22.5974214,22.1556382 C22.5974214,22.8156971 22.0702092,23.3507806 21.4198599,23.3507807 L16.1595115,23.3507807 L16.1595115,24.0966543 C16.1618778,25.5988584 17.3611514,26.8160371 18.8412577,26.8184387 L23.998462,26.8184387 L23.998462,26.8184387 C24.6464378,26.8027804 25.1842328,27.3232174 25.1996608,27.9808674 C25.2150888,28.6385174 24.7023075,29.1843416 24.0543317,29.2 L24.0543317,29.2 Z" id="Shape"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            Preisrechner
                        </button>
                    </div>
                </div>
            </div>

        </>
    )
}
